import { post } from '@/server/axios'
// 创建公告
function create_post(params, option) {
  return post(
    `${process.env.VUE_APP_ANNOUNCEMENT_CENTER}/announcement-center/create`,
    params,
    option
  ).then(response => response)
}
// 更新公告
function update_post(params, option) {
  return post(
    `${process.env.VUE_APP_ANNOUNCEMENT_CENTER}/announcement-center/update`,
    params,
    option
  ).then(response => response)
}
// 获取公告列表
function page_post(params, option) {
  return post(
    `${process.env.VUE_APP_ANNOUNCEMENT_CENTER}/announcement-center/page`,
    params,
    option
  ).then(response => response)
}
// 获取公告明细
function detail_post(params, option) {
  return post(
    `${process.env.VUE_APP_ANNOUNCEMENT_CENTER}/announcement-center/detail`,
    params,
    option
  ).then(response => response)
}
// 导出阅读记录
function export_read_record_post(params, option) {
  return post(
    `${process.env.VUE_APP_ANNOUNCEMENT_CENTER}/announcement-center/export-read-record`,
    params,
    option
  ).then(response => response)
}
// 阅读记录
function read_record_post(params, option) {
  return post(
    `${process.env.VUE_APP_ANNOUNCEMENT_CENTER}/announcement-center/read-record`,
    params,
    option
  ).then(response => response)
}
// 更新已读
function update_read_status_post(params, option) {
  return post(
    `${process.env.VUE_APP_ANNOUNCEMENT_CENTER}/announcement-center/update-read-status`,
    params,
    option
  ).then(response => response)
}
// 修改公告状态
function update_status_post(params, option) {
  return post(
    `${process.env.VUE_APP_ANNOUNCEMENT_CENTER}/announcement-center/update-status`,
    params,
    option
  ).then(response => response)
}
// 获取公告详情
function read_detail_post(params, option) {
  return post(
    `${process.env.VUE_APP_ANNOUNCEMENT_CENTER}/announcement-center/read-detail`,
    params,
    option
  ).then(response => response)
}
// 公告数量
function count_post(params, option) {
  return post(
    `${process.env.VUE_APP_ANNOUNCEMENT_CENTER}/announcement-center/count`,
    params,
    option
  ).then(response => response)
}
// 未读公告数量
function unread_count_post(params, option) {
  return post(
    `${process.env.VUE_APP_ANNOUNCEMENT_CENTER}/announcement-center/unread-count`,
    params,
    option
  ).then(response => response)
}
export const announcementCenter = {
  create_post,
  update_post,
  page_post,
  detail_post,
  export_read_record_post,
  read_record_post,
  update_read_status_post,
  update_status_post,
  read_detail_post,
  count_post,
  unread_count_post
}
